import { useGetQueueRequestsCountQuery } from 'hooks/queue';
import { useAuthContext } from 'context/useAuthContext';
import { useLocationsStore } from 'hooks/useLocationsStore';

/**
 * Hook to get the pending count for the current user
 * - Bookkeeper admins see the count of items waiting on the client (Client view)
 * - Regular users see the count of items assigned to them (Me view)
 */
export const useAskRequestsPendingCount = () => {
  const { isBookkeeperAdmin } = useAuthContext();
  const currentLocationId = useLocationsStore(state => state.currentLocationId);
  const { data: askRequestsCount, isSuccess: ftStatus } = useGetQueueRequestsCountQuery({
    locationId: currentLocationId,
  });

  if (!ftStatus || !askRequestsCount) {
    return 0;
  }

  // Bookkeeper admins see Client count (items waiting on client response)
  // Regular users see Me count (items assigned to them)
  return isBookkeeperAdmin ? askRequestsCount.Client : askRequestsCount.Me;
};
